import React from 'react';
import { Link } from 'react-router-dom';
import logoFull from '../images/ThiranX Logo -.png';

/* ─── PALETTE ─────────────────────────────────────────────── */
const V1 = '#7F00FF';
const V2 = '#B163FF';
const V3 = '#51158C';

/* ─── SVG ICONS ───────────────────────────────────────────── */
const BookOpenIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
  </svg>
);
const ShieldIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const UserPlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <line x1="19" y1="8" x2="19" y2="14" /><line x1="22" y1="11" x2="16" y2="11" />
  </svg>
);
const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
const MailIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);
const MapPinIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);
const HeartIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);
const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37a4 4 0 1 1-7.914 1.174A4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);
const LinkedInIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" />
  </svg>
);

const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/thiranx_2026?igsh=Y3Q0dG4ycmxpc2x5', Icon: InstagramIcon },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/thiranx/', Icon: LinkedInIcon },
];

const Footer = () => (
  <footer style={{ background: 'var(--footer-bg, var(--bg2))', borderTop: '1px solid var(--border)' }}>
    <div className="container" style={{ padding: '64px 28px 32px' }}>

      {/* Top Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr 1fr 1fr', gap: 48, marginBottom: 56 }} className="footer-grid">

        {/* Brand column */}
        <div>
          <div style={{ marginBottom: 16 }}>
            <img
              src={logoFull}
              alt="ThiranX"
              className="footer-logo"
              style={{ height: 60, objectFit: 'contain' }}
            />
          </div>
          <p style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.78, maxWidth: 260, marginBottom: 24 }}>
            Empowering Tamil Nadu's next generation of tech professionals with industry-focused courses and verified certificates.
          </p>

          {/* Social badges */}
          <div style={{ display: 'flex', gap: 10 }}>
            {[
              { label: '500+ Students', bg: `${V3}44`, border: `${V1}33` },
              // { label: '94% Placement', bg: 'rgba(13,186,121,0.1)', border: 'rgba(13,186,121,0.25)' },
            ].map((b, i) => (
              <span key={i} style={{
                display: 'inline-flex', padding: '4px 12px', borderRadius: 999,
                fontSize: 11, fontWeight: 700,
                color: i === 0 ? V2 : 'var(--success)',
                background: b.bg, border: `1px solid ${b.border}`,
              }}>{b.label}</span>
            ))}
          </div>

          {/* Social links */}
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            {SOCIAL_LINKS.map(({ label, href, Icon }) => (
              <a
                key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  width: 36, height: 36, borderRadius: 10,
                  color: 'var(--muted)', border: '1px solid var(--border)',
                  transition: 'color 0.2s, border-color 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.color = V2; e.currentTarget.style.borderColor = `${V1}55`; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--muted)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        {/* Platform links */}
        <div>
          <h4 style={{ color: 'var(--text)', marginBottom: 20, fontSize: 12, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Platform</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {[
              { to: '/courses', icon: <BookOpenIcon />, label: 'All Courses' },
              { to: '/ai', icon: <BookOpenIcon />, label: 'ThiranX AI' },
              { to: '/verify', icon: <ShieldIcon />, label: 'Verify Certificate' },
              { to: '/register', icon: <UserPlusIcon />, label: 'Join Now' },
            ].map(({ to, icon, label }) => (
              <Link key={to} to={to} style={{
                display: 'flex', alignItems: 'center', gap: 8,
                color: 'var(--muted)', fontSize: 14, fontWeight: 500,
                transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.currentTarget.style.color = V2}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
              >
                <span style={{ color: V2, flexShrink: 0 }}>{icon}</span>{label}
              </Link>
            ))}
          </div>
        </div>

        {/* Company links */}
        <div>
          <h4 style={{ color: 'var(--text)', marginBottom: 20, fontSize: 12, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Company</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {[
              { to: '/about', icon: <InfoIcon />, label: 'About ThiranX' },
              { to: '/contact', icon: <MailIcon />, label: 'Contact Us' },
            ].map(({ to, icon, label }) => (
              <Link key={to} to={to} style={{
                display: 'flex', alignItems: 'center', gap: 8,
                color: 'var(--muted)', fontSize: 14, fontWeight: 500, transition: 'color 0.2s',
              }}
                onMouseEnter={e => e.currentTarget.style.color = V2}
                onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
              >
                <span style={{ color: V2, flexShrink: 0 }}>{icon}</span>{label}
              </Link>
            ))}
            {[{ label: 'Privacy Policy' }, { label: 'Terms of Service' }].map(({ label }) => (
              <span key={label} style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--muted)', fontSize: 14, cursor: 'default' }}>
                <span style={{ width: 14, height: 14 }} />{label}
              </span>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <h4 style={{ color: 'var(--text)', marginBottom: 20, fontSize: 12, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Contact</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <a href="tel:+916381253611" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--muted)', fontSize: 14, textDecoration: 'none', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = V2}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
            >
              <span style={{ color: V2, flexShrink: 0 }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg></span>+91 63812 53611
            </a>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--muted)', fontSize: 14 }}>
              <span style={{ color: V2, flexShrink: 0 }}><MailIcon /></span>support@thiranx.in
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--muted)', fontSize: 14 }}>
              <span style={{ color: V2, flexShrink: 0 }}><MapPinIcon /></span>Tamil Nadu, India
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div style={{ height: 1, background: 'var(--border)', marginBottom: 28 }} />

      {/* Bottom row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, alignItems: 'center' }}>
        <p style={{ color: 'var(--muted)', fontSize: 13 }}>
          © {new Date().getFullYear()} ThiranX. All rights reserved.
        </p>
        <p style={{ color: 'var(--muted)', fontSize: 13, display: 'flex', alignItems: 'center', gap: 5 }}>
          Made by <span style={{ color: V2, fontWeight: 700 }}>ThiranX Team</span>
        </p>
      </div>
    </div>

    <style>{`
      .footer-logo { height: 60px !important; }
      @media (max-width: 900px) {
        .footer-grid { grid-template-columns: 1fr 1fr !important; }
        .footer-logo { height: 52px !important; }
      }
      @media (max-width: 540px) {
        .footer-grid { grid-template-columns: 1fr !important; }
        .footer-logo { height: 46px !important; }
      }
    `}</style>
  </footer>
);

export default Footer;
